package navigation.home.service.allservice

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.TabOptions
import cafe.adriel.voyager.transitions.SlideTransition
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import navigation.utils.NavLinkTab

object AllServiceScreenTab : NavLinkTab {

    override var innerNavigator: Navigator? by mutableStateOf(null)

    override val options: TabOptions
        @Composable
        get() {
            val title = "Services"
            val icon = esIconPainterResource(EsIcons.Service)
            val index: UShort = 1u

            return TabOptions(
                index, title, icon,
            )
        }

    @Composable
    override fun Content() {
        Navigator(AllServiceScreenNav) { navigator ->

            DisposableEffect(navigator) {
                innerNavigator = navigator

                onDispose {
                    innerNavigator = null
                }
            }

            SlideTransition(navigator)
        }
    }
}